import { render, staticRenderFns } from "./fragment-real-field.vue?vue&type=template&id=13d8a48e&scoped=true&"
import script from "./fragment-real-field.vue?vue&type=script&lang=js&"
export * from "./fragment-real-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d8a48e",
  null
  
)

export default component.exports